/* exo-collection.js — ajout au panier depuis les pages collection (04/10/2026).
   Un seul produit : [data-dcr-add="variantId"] ; une offre groupée : [data-dcr-bundle='[{id,quantity}...]']
   avec les propriétés _bundle_* que lit snippets/exo-cart-bundle-card.liquid.
   Le sélecteur de formats (.dcr__fmt) met à jour le prix et la variante du bouton de sa carte. */
(function () {
  if (window.__exoCollectionBound) return;
  window.__exoCollectionBound = true;

  function drawer() {
    if (typeof window.refreshSections === 'function' && typeof window.openDrawer === 'function') {
      return window.refreshSections().then(window.openDrawer);
    }
    window.location.href = '/cart';
  }

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!(radio && radio.matches && radio.matches('.dcr__fmt input[type=radio]'))) return;
    var foot = radio.closest('.dcr__foot');
    var price = foot && foot.querySelector('[data-dcr-price]');
    var btn = foot && foot.querySelector('[data-dcr-fmt-target]');
    if (price) price.textContent = radio.getAttribute('data-price-text');
    if (btn) { btn.setAttribute('data-dcr-add', radio.value); btn.setAttribute('data-price', radio.getAttribute('data-price')); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.dcr [data-dcr-add], .dcr [data-dcr-bundle]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var bundle = btn.getAttribute('data-bundle-id'), label = btn.getAttribute('data-bundle-label') || '';
    var totalCents = parseInt(btn.getAttribute(bundle ? 'data-bundle-total' : 'data-price'), 10) || 0;
    var items;
    if (bundle) {
      var raw = JSON.parse(btn.getAttribute('data-dcr-bundle'));
      var save = btn.getAttribute('data-bundle-savings') || '0';
      items = raw.map(function (it, i) {
        return { id: it.id, quantity: it.quantity || 1, properties: {
          '_bundle_id': bundle, '_bundle_label': label,
          '_bundle_total_cents': String(totalCents), '_bundle_savings_cents': String(save),
          '_bundle_position': String(i + 1), '_bundle_size': String(raw.length) } };
      });
    } else {
      items = [{ id: parseInt(btn.getAttribute('data-dcr-add'), 10), quantity: 1 }];
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
    .then(function (data) {
      var value = totalCents / 100;
      try {
        if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_name: label || 'collection', content_ids: items.map(function (i) { return String(i.id); }), content_type: 'product', value: value, currency: 'EUR', num_items: items.length });
        if (typeof window.gtag === 'function') window.gtag('event', 'add_to_cart', { currency: 'EUR', value: value, items: items.map(function (i) { return { item_id: String(i.id), quantity: 1 }; }) });
        if (bundle) window.dispatchEvent(new CustomEvent('exo:bundle:added', { detail: { bundle: label, items: items, cart: data, value: value } }));
      } catch (err) {}
      return drawer();
    })
    .catch(function () { window.location.href = '/cart'; })
    .then(function () { btn.removeAttribute('aria-busy'); });
  });
})();
